class ApiVuePlugin {
  static install (Vue, options) {
    Vue.prototype.$api = options.api
    Vue.prototype.$apiConnection = options.connection
  }
}
export default ApiVuePlugin



// WEBPACK FOOTER //
// ./src/api/ApiVuePlugin.js